import $ from 'jquery';

import SinglePaymentLoanCalculator from '@components/SinglePaymentLoanCalculator';
import InstallmentCalculator from '@components/InstalmentCalculator';
import App from '@components/App';
import AjaxForm from '@components/AjaxForm';
import Cache from "@utils/Cache";

class Application extends App {
    constructor() {
        super();
    }

    bindEvents() {
        $(() => {
            if ($('[data-openpopup]:not(.has_openpopup_script)').length > 0) {
                popup_open();
                popup_close();
            }

            $('select[name="firstRegistrationDate[day]"], select[name="firstRegistrationDate[month]"], select[name="firstRegistrationDate[year]"]').on('change', function () {
                $(this).parents('.input-wrapper').removeClass('wrong');
                $(this).parents('.input-wrapper').find('.error_msg').hide();
            });

            $('.application-choice-radios label').loadify({
                callback:function(tr,c){
                    var url = tr.find('input').attr('data-url');
                    if (typeof url != 'undefined') {
                        window.location.href = url;
                    }
                }
            });

            $('.submit-application-form-step-two, .continue_submit', $('.new_application')).on('click', function (e) {
                e.preventDefault();
                var $applicationForm = $('.new_application');

                if($(this).hasClass('continue_submit')) {
                    $('.linked_cinputs').find('.cinput').each(function () {
                        $(this).addClass('optional');
                    });
                    $applicationForm.append('<input type="hidden" name="ignore_sms_code" value="1">');
                }

                var btn = $(this);

                var defaultText = btn.data('default_text');
                var waitText = btn.data('wait_text');

                if (btn.hasClass('disabled')) {
                    return;
                }

                btn.addClass('disabled').text(waitText).append($('<span class="animated_dots"></span>'));
                animated_dots();

                let aForm = new AjaxForm();
                aForm.init($applicationForm);
                aForm.validate();

                if (aForm.isValid()) {

                    aForm.submit(function (result) {
                        if (aForm.isSuccess()) {
                            window.location = $applicationForm.attr('data-redirect');
                        } else {

                            btn.removeClass('disabled').text(defaultText);

                            if(aForm.response.errors[0] == "API call was not successfull") {
                                $('#api_error').show();
                                $(document).scrollTop( 300 );
                            }
                        }
                    });
                } else {

                    btn.removeClass('disabled').text(defaultText);
                }
            });

            $('.submit-application-form', $('.new_application')).on('click', function (e) {
                e.preventDefault();
                var $applicationForm = $('.new_application');
                var $submitBtn = $(this);
                var defaultText = $submitBtn.data('default_text');
                var waitText = $submitBtn.data('wait_text');

                if ($submitBtn.hasClass('disabled')) {
                    return;
                }

                $submitBtn.addClass('disabled').text(waitText).append($('<span class="animated_dots"></span>'));
                animated_dots();

                let aForm = new AjaxForm();
                aForm.init($applicationForm);
                aForm.validate();

                if (aForm.isValid()) {

                    aForm.submit(function (result) {
                        if (aForm.isSuccess()) {
                            window.location = $applicationForm.attr('data-redirect');
                        } else {

                            $submitBtn.removeClass('disabled').text(defaultText);

                            if(aForm.response.errors[0] == "API call was not successfull") {
                                $('#api_error').show();
                                $(document).scrollTop( 300 );
                            }


                        }


                    });
                } else {
                    $submitBtn.removeClass('disabled').text(defaultText);
                }

            });


            $('.cinput.invalid,.checkbox-line:not(.checked)', $('.new_application')).on('click', function () {
                AjaxForm.inputClick($(this));
            });


            $('.cinput.invalid input,.checkbox-line:not(.checked)  input, .cselect input, .cselect select', $('.new_application')).on('focus', function () {
                AjaxForm.inputClick($(this).parent());
            });

            $('.new_application input[name=registration_citizen_type]').on('change', function () {
                $('label.radio_cont.default_border_darker').removeClass('invalid');
                $('#citizen-not-selected').hide();
            });
        });
    }

    init() {
        ENV === 'development' && console.log('Application::init()');

        super.init();

        this.bindEvents();

        SinglePaymentLoanCalculator.init();
        InstallmentCalculator.init();

    }
}

export default Application;
